import {
  ChangeDetectorRef,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { interval, Subscription } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { HttpService } from 'src/app/services/http.service';
import { HomeComponent } from '../home/home.component';
import { HttpClient } from '@angular/common/http';
import { DatePipe, CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { DashboardPopupComponent } from './dashboard-popup/dashboard-popup.component';
import { MatSort } from '@angular/material/sort';
import { CdkTableModule } from '@angular/cdk/table';

interface PageNameMappings {
  [key: string]: string;
}

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CdkTableModule, HomeComponent, DatePipe, CommonModule],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DashboardComponent implements OnInit {
  pageName: string = '';
  inData: any[] = [];
  outData: any[] = [];
  totalHeadcount: number = 0;
  count: number = 0;
  functAllCount: { [key: string]: number } = {};
  areaTypeName: string = '';
  areaTypes: string = '';
  pollingInterval = 1000;
  pollingSubscription: Subscription = null!;
  functTypeList: any[] = [];
  functTypeKey: string = '';
  isTableVisible: boolean = false;
  pageNameMappings: PageNameMappings = {};
  currentDate: Date = new Date();
  private timeUpdateInterval: Subscription = null!;
  currentTime: string = '';
  clientImage: any = '';

  displayedColumns: string[] = ['EmpID', 'designation', 'Name', 'mobileNumber'];
  dataSource = new MatTableDataSource<any>(this.functTypeList);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  constructor(
    private httpService: HttpService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.loadPageNameMappings();
    this.startPolling();
    console.log('start');
    this.updateCurrentTime();
  }

  ngOnDestroy(): void {
    this.stopPolling();
    if (this.timeUpdateInterval) {
      this.timeUpdateInterval.unsubscribe();
    }
  }

  startPolling(): void {
    this.pollingSubscription = interval(this.pollingInterval).subscribe(() => {
      this.pageName = this.route.snapshot.params['page'];
      this.areaTypeName = this.formatPageName(
        this.route.snapshot.params['page']
      );
      this.loadTotalHeadcount();
    });
  }

  stopPolling(): void {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }

  updateCurrentTime(): void {
    this.timeUpdateInterval = interval(1000).subscribe(() => {
      const options: Intl.DateTimeFormatOptions = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      };
      this.currentTime = new Date().toLocaleTimeString(undefined, options);
    });
  }

  loadPageNameMappings() {
    this.http
      .get<{ pageNameMappings: { [key: string]: string } }>('assets/users.json')
      .subscribe(
        (data) => {
          this.pageNameMappings = data.pageNameMappings;
        },
        (error) => {
          console.error('Error loading page name mappings:', error);
        }
      );
  }

  formatPageName(pageName: string): string {
    const formattedName = this.pageNameMappings[pageName.toLowerCase()];
    return formattedName ? formattedName : pageName;
  }

  loadTotalHeadcount() {
    this.httpService.getTotalHeadcount(this.pageName).subscribe(
      (data: any) => {
        this.functAllCount = data.result.designationCount;
        this.totalHeadcount = data.result.total;
      },
      (error) => {
        console.error('Error retrieving data:', error);
      }
    );
    this.loadInData();
    this.loadFunctTypeList(this.functTypeKey);
  }

  loadInData() {
    this.httpService.getInAndOutData(this.pageName).subscribe(
      (data: any) => {
        this.inData = data.result.inData;
        this.outData = data.result.outData;
      },
      (error) => {
        console.error('Error retrieving data:', error);
      }
    );
  }

  loadFunctTypeList(functTypeKey: string): void {
    this.httpService.getFunctListData(this.pageName).subscribe(
      (data: any) => {
        this.functTypeList = data.result.employeeDetails;
        this.dataSource.data = this.functTypeList;
      },
      (error) => {
        console.error('Error retrieving functTypeList data:', error);
      }
    );
  }

  getFunctTypeKeys(): string[] {
    return Object.keys(this.functAllCount);
  }

  functTypelick(functTypeKey: string): void {
    this.loadFunctTypeList(functTypeKey);
    this.isTableVisible = true;
    this.openTablePopup(functTypeKey);
  }

  openTablePopup(functTypeKey: string): void {
    console.log('===>', functTypeKey);
    const isMobile = window.innerWidth < 1000;

    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = isMobile ? '90%' : '40%';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.height = isMobile ? '90%' : '80%';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.data = { functTypeKey, functTypeList: this.functTypeList };
    console.log('dialogConfig.data', dialogConfig.data);

    this.dialog.open(DashboardPopupComponent, dialogConfig);
  }

  applyFilter(filterValue: string): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}